import { ServiceCommon } from "../booking";

export const generateToken = async (patientid: string) => {
  try {
    const authPath = `${process.env.TL_API}/auth/medication`;
    const payload = {
      patientId: patientid ?? process.env.PROVIDER_ID,
      providerId: process.env.PROVIDER_ID,
      secret: process.env.PROVIDER_SECRET,
    };
    const result = await fetch(authPath, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    return await result.json();
  } catch (error) {
    console.warn(error);
    return undefined;
  }
};

export const getPatientServices = async (token: string, patientid: string) => {
  try {
    const path = `${process.env.TL_API}/staff?patientId=${patientid ?? null}`;
    const res = await fetch(path, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.warn(error);
    return undefined;
  }
};

export const getServices = async ({
  token,
  serviceId,
  staffId,
  patientId,
  state,
  payor,
  utm_source,
}: {
  token: string;
  serviceId: string;
  staffId?: string | null;
  patientId?: string | null;
  state?: string | null;
  payor?: string | null;
  utm_source?: string | null;
}) => {
  try {
    const path = `${process.env.TL_API}/staff?service=${serviceId}&staffId=${
      staffId ?? ""
    }&patientId=${patientId ?? ""}&state=${state ?? ""}&payor=${payor ?? ""}&utm_source=${utm_source}`;
    const res = await fetch(path, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();
    return data;
  } catch (error) {
    console.warn(error);
    return undefined;
  }
};

export const getPatientInfo = async (
  token: string,
  email: string,
  patientId?: string,
): Promise<Partial<ServiceCommon>> => {
  try {
    const path = `${process.env.TL_API}/patient/${email}`;
    const res = await fetch(path, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();
    let patient;
    if (data) {
      const {
        mailingStreet,
        mailingCity,
        mailingState,
        mailingCountry,
        mailingZip,
        gender,
        email,
        FirstName,
        LastName,
        phone,
      } = data;
      patient = {
        first_name: FirstName,
        last_name: LastName,
        email,
        phone,
        street: mailingStreet,
        city: mailingCity,
        gender,
        state: mailingState,
        zip: mailingZip,
        country: mailingCountry,
        patientId: data?.patientId
          ? data?.patientId
          : data?.patientId_long
            ? data?.patientId_long
            : patientId ?? null,
      };
    }

    return patient ?? { first_name: "", last_name: "", patientId: null };
  } catch (error) {
    console.warn(error);
    return {};
  }
};

export const getWorkspaces = async (token: string) => {
  const result = await fetch(`${process.env.TL_API}/staff/workspaces`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return await result.json();
};

export const getWorkspaceService = async (id: string, token: string) => {
  const result = await fetch(
    `${process.env.TL_API}/staff/workspace-service?id=${id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return await result.json();
};
